import type { Hunt } from '@wehunt/ui'

export interface HuntsListSources {
  /** Hunts the viewer was invited to. */
  upcoming: Hunt[]
  /** Live hunts (ongoing/paused) the viewer is on the roster of. */
  ongoing: Hunt[]
  /** Hunts their teams have planned that they were not invited to. */
  notInvitedTeam: Hunt[]
  ended: Hunt[]
  drafts: Hunt[]
}

/**
 * Assembles the hunts list from its sources.
 *
 * Extracted from the route because the order is meaningful — the page groups by
 * status and a hunt appearing in the wrong group is a real bug — and because the
 * route itself needs eight hooks to mount, which puts this composition out of reach
 * of a test.
 */
export function composeHuntsList(sources: HuntsListSources): Hunt[] {
  return [
    ...sources.ongoing,
    ...sources.upcoming,
    ...sources.notInvitedTeam,
    ...sources.ended,
    ...sources.drafts,
  ]
}
